var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTestopsCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-653.000000, -542.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-testopsCI",
    transform: "translate(653.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#57CFFF",
    points: "-1.42108547e-14 35 17.4816749 35 14.3714453 32.5175667 34.2737617 2.48689958e-14 -1.42108547e-14 2.48689958e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#4D94FF",
    points: "34.2737617 35 13.3886719 35 6.26621503 23.2356187 20.2103579 11.875"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.5,
    cy: 17.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16,22.24 C13.776,22.24 14.31,22.152 14.762,21.976 C15.214,21.8 15.588,21.608 15.884,21.4 C16.228,21.152 16.52,20.872 16.76,20.56 L16.76,20.56 L15.44,19.12 C15.264,19.328 15.064,19.508 14.84,19.66 C14.64,19.796 14.4,19.92 14.12,20.032 C13.84,20.144 13.52,20.2 13.16,20.2 C12.816,20.2 12.498,20.14 12.206,20.02 C11.914,19.9 11.66,19.732 11.444,19.516 C11.228,19.3 11.06,19.046 10.94,18.754 C10.82,18.462 10.76,18.144 10.76,17.8 C10.76,17.456 10.82,17.138 10.94,16.846 C11.06,16.554 11.228,16.3 11.444,16.084 C11.66,15.868 11.914,15.7 12.206,15.58 C12.498,15.46 12.816,15.4 13.16,15.4 C13.504,15.4 13.81,15.456 14.078,15.568 C14.346,15.68 14.572,15.804 14.756,15.94 C14.972,16.1 15.16,16.28 15.32,16.48 L15.32,16.48 L16.7,15.04 C16.46,14.728 16.168,14.448 15.824,14.2 C15.528,13.992 15.16,13.8 14.72,13.624 C14.28,13.448 13.76,13.36 13.16,13.36 C12.496,13.36 11.88,13.478 11.312,13.714 C10.744,13.95 10.25,14.272 9.83,14.68 C9.41,15.088 9.08,15.56 8.84,16.096 C8.6,16.632 8.48,17.2 8.48,17.8 C8.48,18.4 8.6,18.968 8.84,19.504 C9.08,20.04 9.41,20.512 9.83,20.92 C10.25,21.328 10.744,21.65 11.312,21.886 C11.88,22.122 12.496,22.24 13.16,22.24 Z M20.24,22 L20.24,13.6 L17.96,13.6 L17.96,22 L20.24,22 Z",
    id: "CI",
    fill: "#4D94FF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestopsCi);
export default __webpack_public_path__ + "static/media/logo_testops_ci.65696e991f4d27f6f5fb19d0d90cdcd2.svg";
export { ForwardRef as ReactComponent };